export default "__VITE_ASSET__q$memhER__"